import React from "react";
import { initI18nFromSSR } from "./i18n/initFromSSR";

//init dayjs
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import ProductDetail from "./features/productdetail/ProductDetail";
import ProductOrderWindowBlocks from "./features/productdetail/ProductOrderWindowBlocks";
import ProductFlashSaleBlocks from "./features/productdetail/ProductFlashSaleBlocks";
import {
  getJsonAttribute,
  getNumberAttribute,
} from "../frontend/bootstrap/runtime";
import {
  IslandRegistry,
  mountIsland,
} from "../frontend/bootstrap/islandRegistry";

dayjs.extend(utc);
dayjs.extend(timezone);

// Initialize i18n from SSR data và đợi load xong trước khi render
initI18nFromSSR().then(() => {
  const registry = new IslandRegistry();

  registry.register("productDetail", () => {
    mountIsland("product-detail-app", (root) => {
      const productProps = getJsonAttribute(root, "data-product-props", null);
      const productSettings = getJsonAttribute(
        root,
        "data-product-settings",
        null
      );

      return (
        <ProductDetail
          productProps={productProps}
          productSettings={productSettings}
          selectedPricePolicyId={getNumberAttribute(
            root,
            "data-active-price-policy-id",
            0
          )}
          websitePricePolicyId={getNumberAttribute(
            root,
            "data-website-price-policy-id",
            0
          )}
        />
      );
    });
  });

  registry.register("productOrderWindowBlocks", () => {
    mountIsland("product-orderwindow-blocks", (root) => {
      const orderWindows = getJsonAttribute(root, "data-order-windows", []);
      const owProduct = getJsonAttribute(root, "data-product", null);
      const owPricePolicyId = getNumberAttribute(root, "data-price-policy-id", 0);
      const owAllowBuyNow = getNumberAttribute(root, "data-allow-buy-now", 0) === 1;
      const owDefaultWeightPresets = getJsonAttribute(
        root,
        "data-default-weight-presets",
        []
      );

      if (!orderWindows.length || !owProduct) {
        return null;
      }

      return (
        <ProductOrderWindowBlocks
          orderWindows={orderWindows}
          product={owProduct}
          pricePolicyId={owPricePolicyId}
          allowBuyNow={owAllowBuyNow}
          defaultWeightPresets={owDefaultWeightPresets}
        />
      );
    });
  });

  registry.register("productFlashSaleBlocks", () => {
    mountIsland("product-flashsale-blocks", (root) => {
      const flashSales = getJsonAttribute(root, "data-flash-sales", []);
      const fsProduct = getJsonAttribute(root, "data-product", null);
      const fsPricePolicyId = getNumberAttribute(root, "data-price-policy-id", 0);
      const fsAllowBuyNow = getNumberAttribute(root, "data-allow-buy-now", 0) === 1;
      const fsDefaultWeightPresets = getJsonAttribute(
        root,
        "data-default-weight-presets",
        []
      );

      if (!flashSales.length || !fsProduct) {
        return null;
      }

      return (
        <ProductFlashSaleBlocks
          flashSales={flashSales}
          product={fsProduct}
          pricePolicyId={fsPricePolicyId}
          allowBuyNow={fsAllowBuyNow}
          defaultWeightPresets={fsDefaultWeightPresets}
        />
      );
    });
  });

  registry.mountAll();
});

